<div class="no-access-wrapper">
  <mat-card class="no-access-card">
    <mat-card-header class="no-access-header">
      <div mat-card-avatar class="no-access-avatar">
        <mat-icon>lock</mat-icon>
      </div>
      <mat-card-title>{{ 'noAccess.title' | translate }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <p class="no-access-text">{{ 'noAccess.message1' | translate }}</p>
      <p class="no-access-sub" [innerHTML]="'noAccess.message2' | translate"></p>
    </mat-card-content>

    <mat-card-actions align="end">
      <button mat-stroked-button color="primary" routerLink="/my-account">{{ 'noAccess.goToProfile' | translate }}</button>
    </mat-card-actions>
  </mat-card>
</div>
